module.exports = __webpack_public_path__ + "static/media/36-15.9a3bb5ca.mp3";